import { action } from '@ember/object';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

import BoardsShareScheduleCustomSubjectAndNoteComponent from 'webapp/components/boards/share/schedule/custom-subject-and-note';
import BoardsShareScheduleIncludeBgImagesComponent from 'webapp/components/boards/share/schedule/include-bg-images';
import BoardsShareScheduleShareableLinkComponent from 'webapp/components/boards/share/schedule/shareable-link';
import SectionWithTogglerComponent from 'webapp/components/section-with-toggler';
import TimezoneDescriptionComponent from 'webapp/components/timezone-description';

import type { BoardShare, ReportScheduleSetting } from 'webapp/models-custom';

interface Args {
	model: BoardShare | ReportScheduleSetting;
	submitInProgress: boolean;
	onContentChange: () => void;
	isPeriodic: boolean;
	isPagelessFormat?: boolean;
	// Only the boards share form shows the "Shareable link" checkbox
	showShareableLink?: boolean;
}

interface AdvancedSettingsSignature {
	Args: Args;
	// Rendered at the top of the section (boards passes its Date range here)
	Blocks: {
		default: [];
	};
}

export default class BoardsShareScheduleAdvancedSettingsComponent extends Component<AdvancedSettingsSignature> {
	@tracked isOpen = false;

	@action
	toggleOpen() {
		this.isOpen = !this.isOpen;
		this.args.onContentChange();
	}

	<template>
		<SectionWithTogglerComponent
			@isOpen={{this.isOpen}}
			@title="Advanced settings"
			@toggle={{this.toggleOpen}}
		>
			{{yield}}

			{{#if @isPeriodic}}
				<TimezoneDescriptionComponent @timezone={{@model.scheduleUser.timezone}} />
			{{/if}}

			<div class="row row--checkboxes">
				<label>Include</label>
				<div class="right">
					<BoardsShareScheduleIncludeBgImagesComponent
						@model={{@model}}
						@isPagelessFormat={{@isPagelessFormat}}
					/>
					{{#if @showShareableLink}}
						<BoardsShareScheduleShareableLinkComponent
							@model={{@model}}
							@submitInProgress={{@submitInProgress}}
						/>
					{{/if}}
				</div>
			</div>

			<BoardsShareScheduleCustomSubjectAndNoteComponent
				@model={{@model}}
				@submitInProgress={{@submitInProgress}}
			/>
		</SectionWithTogglerComponent>
	</template>
}
